import React, {Component} from "react";  import config from 'react-global-configuration';
import {Redirect} from "react-router-dom";

export default class Logout extends Component{

    constructor(props){
        super(props);
        localStorage.removeItem("usertoken");
        localStorage.removeItem("selectedUTIDCode");
        localStorage.removeItem("selectedStoreCode");
        localStorage.removeItem("selectedUserMode");
        localStorage.removeItem("userPermission");
        localStorage.removeItem("apiLogs");
        localStorage.removeItem("notfications");

        localStorage.removeItem("UD");
        localStorage.removeItem("MenuList");
        localStorage.removeItem("is_extra_column");
        localStorage.removeItem("extra_columns");
        localStorage.removeItem("extra_columns_query");
        localStorage.removeItem("extra_columns_merchant");
        localStorage.removeItem("state_code");
    }
    render() {
        return <Redirect to ="/"/>
        
    }
}